import React, { useState } from 'react';
import careerData from './../../data/career-history.json';
import { useDarkMode } from '../DarkMode';

// Group careers by company
const groupCareersByCompany = (careerData) => {
    return careerData.reduce((acc, career) => {
        const company = career.company;
        if (!acc[company]) {
            acc[company] = [];
        }
        acc[company].push(career);
        return acc;
    }, {});
};

const Career = () => {
    const { isDarkMode } = useDarkMode();
    const [selectedCareer, setSelectedCareer] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);

    const footerElement = document.getElementById('footer');
    const groupedCareers = groupCareersByCompany(careerData);

    const openModal = (career, company) => {
        setSelectedCareer({ ...career, company });
        setModalVisible(true);
    
        const footerElement = document.getElementById('footer');
        if (footerElement) {
            footerElement.classList.add('blur');
        }
        document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
    };
    

    const closeModal = () => {
        setModalVisible(false);
        setSelectedCareer(null);
        footerElement.classList.remove('blur');
        document.body.style.overflow = ''; // Allow scrolling when modal is closed
    };

    return (
        <div id="career-content" className="p-6">
            <h1 className="text-5xl font-bold mb-6">Career</h1>
            <div className="space-y-12">
                {Object.keys(groupedCareers).map((company, index) => (
                    <div key={index} className="relative">
                        {/* Display company name once */}
                        <h2 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{company}</h2>

                        {/* Connecting Line between boxes */}
                        {groupedCareers[company].length > 1 && (
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-full h-0.5 bg-gray-400"></div>
                            </div>
                        )}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {groupedCareers[company].map((career, idx) => (
                                <div key={career.id || idx} className={`border border-gray-300 p-6 rounded-lg relative ${isDarkMode ? 'bg-neutral-800 dark:border-gray-700' : 'bg-white text-black'} shadow-md`}>
                                    <h3 className={`text-lg font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{career.title}</h3>
                                    <p className={`text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-500'}`}>{career['employement-date']}</p>
                                    <button
                                        onClick={() => openModal(career, company)}
                                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                                    >
                                        View Details
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Modal for displaying selected career details */}
            {modalVisible && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 backdrop-blur-lg">
                    <div className={`relative rounded-lg p-8 max-w-3xl ${isDarkMode ? 'bg-neutral-800 text-white' : 'bg-white text-black'} transition-opacity duration-300 opacity-100 animate-fade-in`}>
                        <button onClick={closeModal} className={`absolute top-0 right-0 m-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'} hover:${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>×</button>
                        <h2 className={`text-xl font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-black-900'}`}>{selectedCareer.title}</h2>
                        <h3 className={`text-l font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-black-300'}`}> {selectedCareer.company} </h3>
                        <ul className="list-disc pl-6 text-left">
                            {selectedCareer.descriptions.map((desc, index) => (
                                <li key={index} className={`text-sm mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{desc}</li>
                            ))}
                        </ul>
                        <button onClick={closeModal} className="bg-blue-500 text-white px-4 py-2 rounded mt-4">Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Career;
